import { dataProps } from './properties'

export const setHolidayMasterList = (state, payload) => {
    state.list = payload
}    

export const setHolidayMasterData = (state, payload) => {
    state.props = payload
} 

export const resetHolidayMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/holidayMaster/mutations.js